import type { Node } from 'react';
import React from 'react';
import { Sections } from 'Components/frameworks/sections/Sections';
type Props = {
  children: Node;
  config: CMSContent;
  lines: Array<any>;
};
export const SectionsLine = ({
  children,
  config: {
    common: { scrollBackward, scrollForward },
  },
  lines = [],
}: Props) => (
  <Sections
    navItems={lines.map((l) => l.props.name)}
    scrollBackwardLabel={scrollBackward}
    scrollForwardLabel={scrollForward}
    className="pt-10"
  >
    {children}
  </Sections>
);
